import { AggWeatherSchema } from 'app/agriculture/hooks/useAggregateChartData/types/AggWeatherSchema';
import { AggPowerSchema } from 'app/agriculture/hooks/useAggregateChartData/types/AggPowerSchema';
import { AggNetworkSchema } from 'app/agriculture/hooks/useAggregateChartData/types/AggNetworkSchema';
import { AggLevelSchema } from 'app/agriculture/hooks/useAggregateChartData/types/AggLevelSchema';

export const aggregationSnapshotConfig = {
    Weather: AggWeatherSchema,
    Power: AggPowerSchema,
    Network: AggNetworkSchema,
    Level: AggLevelSchema,
    GasbotLevel: AggLevelSchema,
} as const;

export type AggregatableSnapshotType = keyof typeof aggregationSnapshotConfig;
